// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file integrations/v1/sync.proto (package integrations.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file integrations/v1/sync.proto.
 */
export const file_integrations_v1_sync: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChppbnRlZ3JhdGlvbnMvdjEvc3luYy5wcm90bxIPaW50ZWdyYXRpb25zLnYxItkDCgpTeW5jUmVzdWx0Eg4KBm9yZ19pZBgBIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAiABKAkSFgoOaW50ZWdyYXRpb25faWQYDCABKAkSHwoXaW50ZWdyYXRpb25fb3duZXJfZW1haWwYDSABKAkSGAoQaW50ZWdyYXRpb25fbmFtZRgDIAEoCRIbChNzb3VyY2VfcmVjb3Jkc19yZWFkGAQgASgFEh4KFnRhcmdldF9yZWNvcmRzX3dyaXR0ZW4YBSABKAUSHQoVdGFyZ2V0X3JlY29yZHNfZmFpbGVkGAYgASgFEh4KFnRhcmdldF9yZWNvcmRzX3NraXBwZWQYByABKAUSLgoKc3RhcnRlZF9hdBgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMAoMY29tcGxldGVkX2F0GAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIrCgpldmVudF92YXJzGAogASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBIwCgtleGl0X3N0YXR1cxgLIAEoDjIbLmludGVncmF0aW9ucy52MS5FeGl0U3RhdHVzEhUKDWVycm9yX2RldGFpbHMYDiABKAkqWQoKRXhpdFN0YXR1cxIbChdFWElUX1NUQVRVU19VTlNQRUNJRklFRBAAEhcKE0VYSVRfU1RBVFVTX1NVQ0NFU1MQARIVChFFWElUX1NUQVRVU19FUlJPUhACYgZwcm90bzM",
		[file_google_protobuf_struct, file_google_protobuf_timestamp],
	);

/**
 * this is the result of a tenant sync
 *
 * @generated from message integrations.v1.SyncResult
 */
export type SyncResult = Message<"integrations.v1.SyncResult"> & {
	/**
	 * org ID of the tenant acted upon
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * workspace ID of the tenant acted upon
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * the external reference ID for the integration
	 *
	 * @generated from field: string integration_id = 12;
	 */
	integrationId: string;

	/**
	 * the email of the user that owns (AKA installed) the integration
	 *
	 * @generated from field: string integration_owner_email = 13;
	 */
	integrationOwnerEmail: string;

	/**
	 * the name of the integration being run
	 *
	 * @generated from field: string integration_name = 3;
	 */
	integrationName: string;

	/**
	 * the number of records read from Flowcode
	 *
	 * @generated from field: int32 source_records_read = 4;
	 */
	sourceRecordsRead: number;

	/**
	 * the number of records written to the target system
	 *
	 * @generated from field: int32 target_records_written = 5;
	 */
	targetRecordsWritten: number;

	/**
	 * the number of records that failed to be written to the target system
	 *
	 * @generated from field: int32 target_records_failed = 6;
	 */
	targetRecordsFailed: number;

	/**
	 * the number of records skipped being written
	 *
	 * @generated from field: int32 target_records_skipped = 7;
	 */
	targetRecordsSkipped: number;

	/**
	 * the start timestamp of the event
	 *
	 * @generated from field: google.protobuf.Timestamp started_at = 8;
	 */
	startedAt?: Timestamp | undefined;

	/**
	 * the timestamp when the sync completed
	 *
	 * @generated from field: google.protobuf.Timestamp completed_at = 9;
	 */
	completedAt?: Timestamp | undefined;

	/**
	 * any custom event variables to save
	 *
	 * @generated from field: google.protobuf.Struct event_vars = 10;
	 */
	eventVars?: JsonObject | undefined;

	/**
	 * exit status represents the status of the job that returned the sync result
	 *
	 * @generated from field: integrations.v1.ExitStatus exit_status = 11;
	 */
	exitStatus: ExitStatus;

	/**
	 * error details for EXIT_STATUS_ERROR
	 *
	 * @generated from field: string error_details = 14;
	 */
	errorDetails: string;
};

/**
 * this is the result of a tenant sync
 *
 * @generated from message integrations.v1.SyncResult
 */
export type SyncResultJson = {
	/**
	 * org ID of the tenant acted upon
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * workspace ID of the tenant acted upon
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * the external reference ID for the integration
	 *
	 * @generated from field: string integration_id = 12;
	 */
	integrationId?: string;

	/**
	 * the email of the user that owns (AKA installed) the integration
	 *
	 * @generated from field: string integration_owner_email = 13;
	 */
	integrationOwnerEmail?: string;

	/**
	 * the name of the integration being run
	 *
	 * @generated from field: string integration_name = 3;
	 */
	integrationName?: string;

	/**
	 * the number of records read from Flowcode
	 *
	 * @generated from field: int32 source_records_read = 4;
	 */
	sourceRecordsRead?: number;

	/**
	 * the number of records written to the target system
	 *
	 * @generated from field: int32 target_records_written = 5;
	 */
	targetRecordsWritten?: number;

	/**
	 * the number of records that failed to be written to the target system
	 *
	 * @generated from field: int32 target_records_failed = 6;
	 */
	targetRecordsFailed?: number;

	/**
	 * the number of records skipped being written
	 *
	 * @generated from field: int32 target_records_skipped = 7;
	 */
	targetRecordsSkipped?: number;

	/**
	 * the start timestamp of the event
	 *
	 * @generated from field: google.protobuf.Timestamp started_at = 8;
	 */
	startedAt?: TimestampJson;

	/**
	 * the timestamp when the sync completed
	 *
	 * @generated from field: google.protobuf.Timestamp completed_at = 9;
	 */
	completedAt?: TimestampJson;

	/**
	 * any custom event variables to save
	 *
	 * @generated from field: google.protobuf.Struct event_vars = 10;
	 */
	eventVars?: StructJson;

	/**
	 * exit status represents the status of the job that returned the sync result
	 *
	 * @generated from field: integrations.v1.ExitStatus exit_status = 11;
	 */
	exitStatus?: ExitStatusJson;

	/**
	 * error details for EXIT_STATUS_ERROR
	 *
	 * @generated from field: string error_details = 14;
	 */
	errorDetails?: string;
};

/**
 * Describes the message integrations.v1.SyncResult.
 * Use `create(SyncResultSchema)` to create a new message.
 */
export const SyncResultSchema: GenMessage<SyncResult, { jsonType: SyncResultJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_sync, 0);

/**
 * exit status is a signal for the status of the sync job when it exited
 *
 * @generated from enum integrations.v1.ExitStatus
 */
export enum ExitStatus {
	/**
	 * @generated from enum value: EXIT_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * success means that the job successfully ran. A sync can run and
	 * have failed records due to validations, but still be successful.
	 *
	 * @generated from enum value: EXIT_STATUS_SUCCESS = 1;
	 */
	SUCCESS = 1,

	/**
	 * error means that the job was interrupted by an unhandled condition
	 *
	 * @generated from enum value: EXIT_STATUS_ERROR = 2;
	 */
	ERROR = 2,
}

/**
 * exit status is a signal for the status of the sync job when it exited
 *
 * @generated from enum integrations.v1.ExitStatus
 */
export type ExitStatusJson = "EXIT_STATUS_UNSPECIFIED" | "EXIT_STATUS_SUCCESS" | "EXIT_STATUS_ERROR";

/**
 * Describes the enum integrations.v1.ExitStatus.
 */
export const ExitStatusSchema: GenEnum<ExitStatus, ExitStatusJson> = /*@__PURE__*/ enumDesc(file_integrations_v1_sync, 0);
